export const GAME_OFFICE_TYPES = [
  'League',
  'Tournament',
  'Cup'
];

export const GAME_OFFICE_RESOURCES = [
  'leagues',
  'tournaments',
  'cups',
]

export const LEAGUE_ROLES = [
  "system",
  "admin",
  "super-admin",
  "director",
  "manager",
  "organizer",
  "association",
  "registrar"
];

export const OFFICIAL_ROLES = [
  "system",
  "admin",
  "super-admin",
  "assigner",
  "assigning-manager",
  "official"
];

export const SID_MEMBER_TYPES = {
  player: "PLAYER",
  coach: "COACH",
  official: "OFFICIAL",
  volunteer: "VOLUNTEER",
  benchStaff: "BENCH_STAFF",
  special: "SPECIAL",
}

export const SURFACE_EVENT_TYPES = {
  GAME: "Game",
  DRAFTGAME: "Draft Game",
  PRACTICE: "Practice",
  TIMESLOT: "Slot",
  AVAILABILITY: "Availability",
}
